<template>
  <header class="header-area" :class="{ 'scrolled': isScrolled }">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <nav class="main-nav">
            <a href="#" @click.prevent="$router.push('/')" class="logo">
              <img src="@/assets/images/logo.png" alt="Logo" />
            </a>

            <Transition name="fade" mode="out-in">
              <ul class="nav" :class="{ 'menu-active': menuActive }">
                <li>
                  <a @click="$router.push({ name: 'home' })" class="cursor-pointer">Home</a>
                </li>

                <!-- Dropdown Ubicaciones -->
                <li 
                  class="dropdown"
                  @mouseover="openDropdown" 
                  @mouseleave="closeDropdown"
                  @click.stop="toggleDropdown"
                >
                  <a href="#" @click.prevent>
                    Ubicaciones <i :class="dropdownOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                  </a>
                  <ul v-show="dropdownOpen" class="dropdown-menu">
                    <li @click="$router.push({ name: 'barcelona' })">Barcelona</li>
                    <li @click="$router.push('/coruna')">A Coruña</li>
                    <li @click="$router.push('/terrassa')">Terrassa</li>
                  </ul>
                </li>

                <li v-for="item in menu" :key="item.name">
                  <a @click="$router.push({ name: item.name })" class="cursor-pointer">
                    {{ item.nameShow }}
                    <i v-if="item.name == 'login'" class="fa fa-sign-in-alt" />
                    <i v-if="item.name == 'booking'" class="fa fa-calendar-alt" />
                  </a>
                </li>
              </ul>
            </Transition>

            <!-- Botó menú hamburguesa (només mòbil) -->
            <a class="menu-trigger" @click="toggleMenu">
              <i v-if="!menuActive" class="fa fa-bars"></i>
              <i v-else class="fa fa-times"></i>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";

export default {
  name: "HeaderView",
  setup() {
    const dropdownOpen = ref(false);
    const menuActive = ref(false);
    const isMobile = ref(window.innerWidth <= 991);
    const isScrolled = ref(false);

    const menu = ref([
      { nameShow: "Eventos", name: "events" },
      { nameShow: "Conócenos", name: "about" },
      { nameShow: "Contacto", name: "contact" },
      { nameShow: "Reserva", name: "booking" },
      { nameShow: "Iniciar Sesión", name: "login" },
    ]);

    const toggleMenu = () => {
      menuActive.value = !menuActive.value;
    };

    const toggleDropdown = () => {
      if (isMobile.value) {
        dropdownOpen.value = !dropdownOpen.value;
      }
    };

    const openDropdown = () => {
      if (!isMobile.value) {
        dropdownOpen.value = true;
      }
    };

    const closeDropdown = () => {
      if (!isMobile.value) {
        dropdownOpen.value = false;
      }
    };

    const closeDropdownOnClickOutside = (event) => {
      if (!event.target.closest(".dropdown")) {
        dropdownOpen.value = false;
      }
    };

    const checkIfMobile = () => {
      isMobile.value = window.innerWidth <= 991;
    };

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50;
    };

    onMounted(() => {
      document.addEventListener("click", closeDropdownOnClickOutside);
      window.addEventListener("resize", checkIfMobile);
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      document.removeEventListener("click", closeDropdownOnClickOutside);
      window.removeEventListener("resize", checkIfMobile);
      window.removeEventListener("scroll", handleScroll);
    });

    return {
      menu,
      menuActive,
      toggleMenu,
      dropdownOpen,
      toggleDropdown,
      openDropdown,
      closeDropdown,
      isScrolled
    };
  },
};
</script>
